
<template>
    
        <mars-view class="container" :class="hidePaddingBootom ? 'hide-pendding-bottom' : ''"><template><top-bar :title="topBar.title" :text-color="topBar.color" :bg-color="topBar.bgColor" :no-left-nav="corePage" :no-right-nav="corePage" :show-title-icon="showTitleIcon" :menu="menu"></top-bar></template><mars-view class="law-upload"></mars-view><slot></slot></mars-view>
    
</template>

<script>
import Topbar from "../../components/common/topbar.vue";
export default {
  components: {
    'top-bar': Topbar
  },
  props: {
    topBar: {
      type: Object,
      default: function () {
        return {
          title: '律临',
          color: '#000',
          bgColor: '#fff'
        };
      }
    },
    corePage: {
      type: Boolean,
      default: false
    },
    menu: {
      type: Array,
      default: function () {
        return [];
      }
    },
    hidePaddingBootom: {
      type: Boolean,
      default: false
    },
    showTitleIcon: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.container {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.hide-pendding-bottom {
  padding-bottom: 0;
}

</style>
